export { ViajesRevisionList } from "./list/list";
export { ViajeCobranzaDetalle } from "./edit";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/index.tsx